import Seo from "../components/Seo";
import PageHeader from "../components/ui-custom/PageHeader";
import { Reveal } from "../components/ui-custom/Reveal";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    eyebrow: "Legal",
    sections: [
      { h: "1. Acceptance of Terms", p: "By accessing or using the utipanagecy platform, you agree to be bound by these Terms of Service and all applicable laws and regulations." },
      { h: "2. Use of Services", p: "You agree to use utipanagecy services only for lawful purposes and in accordance with all applicable financial regulations and KYC requirements." },
      { h: "3. Accounts & Activation", p: "Retailers, distributors and white-label partners are responsible for maintaining the confidentiality of their account credentials and all activity under their account." },
      { h: "4. Fees & Payments", p: "Activation charges, coupon prices and commissions are as listed on the pricing page and may be updated with prior notice." },
      { h: "5. Limitation of Liability", p: "utipanagecy is a facilitation platform. We are not liable for delays or rejections by third-party government or banking channels beyond our control." },
      { h: "6. Changes", p: "We may revise these terms at any time. Continued use of the platform constitutes acceptance of the updated terms." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Legal",
    sections: [
      { h: "1. Information We Collect", p: "We collect information you provide during registration, KYC and transactions, including identity documents required for regulated services." },
      { h: "2. How We Use Data", p: "Data is used solely to deliver services, comply with regulations, prevent fraud and improve the platform experience." },
      { h: "3. Data Security", p: "We apply bank-grade encryption and access controls to protect your data at rest and in transit." },
      { h: "4. Sharing", p: "We share data only with authorised government and banking channels necessary to complete a requested service, and never sell your data." },
      { h: "5. Your Rights", p: "You may request access to or deletion of your personal data, subject to regulatory retention requirements." },
      { h: "6. Contact", p: "For any privacy concerns, reach us at hello@utipanagecy.in." },
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <>
      <Seo title={c.title} description={`${c.title} for the utipanagecy digital services platform.`} />
      <PageHeader eyebrow={c.eyebrow} title={c.title} />
      <section className="mx-auto max-w-3xl px-5 py-16" data-testid={`legal-${type}`}>
        <div className="space-y-8">
          {c.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05} className="rounded-2xl glass p-6">
              <h3 className="text-lg font-semibold text-slate-900">{s.h}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.p}</p>
            </Reveal>
          ))}
        </div>
        <p className="mt-10 text-center text-xs text-slate-400">Last updated: December 2025</p>
      </section>
    </>
  );
}
